<template>
  <div
    class="empty-topic-section color_white_bg rounded-5 d-flex justify-content-center align-items-center nowrap index-1"
    @dragover.prevent
  >
    <div
      class="content d-flex justify-content-center align-items-start"
      @dragover.prevent
    >
      <!-- LEFT -->
      <div class="left" @dragover.prevent>
        <img v-lazy="localImg('warning.png')" alt="warning" />
      </div>

      <!-- RIGHT -->
      <div class="right" @dragover.prevent>
        <div class="text-title brand_primary font-weight-bold">
          No topic Assigned to this Term
        </div>

        <div class="text-meta color_ash">
          Click here to assign topics to this term.
        </div>

        <!-- BUTTON ROW -->
        <div class="button-row d-flex justify-content-start" @dragover.prevent>
          <!-- SELECT TOPICS -->
          <button
            @click="$emit('showTopicSearch')"
            class="btn btn-sm color_ash text-capitalize mx-0 ml-1 mr-3 z-depth-0"
          >
            Search Topics
            <span class="icon-caret-fill-down ml-2 font-5-5"></span>
          </button>

          <!-- CREATE TOPICS -->
          <button
            @click="$emit('showCreateTopicModal')"
            class="btn btn-sm color_ash text-capitalize mx-0 mr-2 z-depth-0"
          >
            Create Topic <span class="icon-plus ml-2 font-14-5"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyTopicList",
};
</script>

<style lang="scss" scoped>
.empty-topic-section {
  padding: 33px;
  border: 1px dashed $border_grey_dark;

  @include breakpoint_max(lg) {
    padding: 25px;
  }

  .left {
    margin-right: 15px;
    img {
      @include equal_min_edge(58);
    }
  }

  .right {
    .text-title {
      margin-bottom: 7px;
      font-size: 15px;
      line-height: 21px;

      @include breakpoint_max(lg) {
        font-size: 13px;
        line-height: 18px;
      }
    }

    .text-meta {
      font-size: 13px;
      line-height: 18px;
      margin-bottom: 15px;

      @include breakpoint_max(lg) {
        font-size: 12px;
        line-height: 15px;
      }
    }

    .btn {
      background: $brand_accent_light;
      border: 1px solid $brand_accent;
      transition: all 0.4s ease-in-out;
      &:hover {
        background: $brand_inverse_light;
        border: 1px solid $brand_inverse;
      }

      @include breakpoint_max(lg) {
        font-size: 10.5px !important;
      }
    }
  }
}
</style>
